import API from '@/api/Task'
import MixinFactory from '@/store/mixin'
const Mixin = MixinFactory('Task')

const state = {
  ...Mixin.state,
}

const mutations = {
  ...Mixin.mutations,
  addComment(state, payload) {
    state.item.comments.forEach(comment => (comment.isProcessed = true))
    state.item.comments.push(payload)
  },
}

const actions = {
  fetch: Mixin.actions.fetch(API.get),
  mutate: Mixin.actions.mutate(API.mutate),
  remove: Mixin.actions.remove(API.delete),
}

const getters = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
